export default {
	ROOT: '/',
	PRODUCT: '/product',
}
